import React from "react"

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo)
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null })
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            fontFamily: "Inter, Arial, sans-serif",
            background: "#f9f9f9",
            padding: "2rem",
            textAlign: "center",
          }}
        >
          <h1
            style={{
              color: "#880356",
              fontSize: "2rem",
              marginBottom: "1rem",
            }}
          >
            Oops! Something went wrong.
          </h1>
          <p
            style={{
              color: "#505050",
              fontSize: "1rem",
              marginBottom: "2rem",
            }}
          >
            The page encountered an unexpected error. Please try refreshing.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              background: "#880356",
              color: "#fff",
              border: "none",
              padding: "0.75rem 2rem",
              borderRadius: "8px",
              fontSize: "1rem",
              cursor: "pointer",
            }}
          >
            Refresh Page
          </button>
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
